class App {
  constructor() {
    this.preDefinedApps = {
      USB: "41",
      MIRACAST: "RunWIFIDisplay",
      YOUTUBE: "111299001912",
      BROWSER: "29_fullbrowser",
      BLUETOOTH: "BtAPP"
    }
  }
  _init = async () => {
    return true
  }
  getList = async () => {
    return [
      { value: "YouTube", key: "111299001912" },
      { value: "WebBrowser", key: "29_fullbrowser" },
      { value: "Bluetooth", key: "BtAPP" },
      { value: "USB", key: "41" },
      { value: "Mirroring", key: "RunWIFIDisplay" }
    ]
  }

  launch = async app_id => {
    let promise = await _$.progress.create()

    await __._source.set("48")

    switch (app_id) {
      case "41":
        __._device.pluginTV.Open("NNavi", "1.000", "NNavi")
        __._device.pluginTV.Execute("SendEventToDevice", 41, 0)
        break
      case "BtAPP":
        __._device.pluginTV.Open("HOTEL", "1.000", "HOTEL")
        __._device.pluginTV.Execute("RunHotelApp", "BtApp", "1")
        __._device.pluginTV.Close()
        break
      case "RunWIFIDisplay":
        __._device.pluginTV.Open("TaskManager", "1.000", "TaskManager")
        __._device.pluginTV.Execute("RunWIFIDisplay")
        __._device.pluginTV.Close()
        break
      default:
        __._api.Widget.runSearchWidget(app_id, app_id === "29_fullbrowser" ? "www.google.com" : "")
        break
    }
    return promise.done
  }
  close = async () => {
    return true
  }
}

export default App
